import { Routes } from '@angular/router';

export const APP_ROUTES: Routes = [
  { path: '', loadChildren: () => import('./features/home/home.module').then((m) => m.HomeModule) },
  {
    path: 'about-us',
    loadChildren: () => import('./features/about-us/about-us.module').then((m) => m.AboutUsModule),
  },
  {
    path: 'join-tribe',
    loadChildren: () => import('./features/join-lm-tribe/join-lm-tribe.module').then((m) => m.JoinLmTribeModule),
  },
  {
    path: 'events',
    loadChildren: () => import('./features/events/events.module').then((m) => m.EventsModule),
  },
  {
    path: 'shop',
    loadChildren: () => import('./features/shop/shop.module').then((m) => m.ShopModule),
  },
  {
    path: 'contact-us',
    loadChildren: () => import('./features/contact-us/contact-us.module').then((m) => m.ContactUsModule),
  },
  {
    path: 'donate',
    loadChildren: () => import('./features/donate/donate.module').then((m) => m.DonateModule),
  },
  {
    path: 'error-page',
    loadChildren: () => import('./features/error-404/error-404.module').then((m) => m.Error404Module),
  },
  {
    path: '',
    redirectTo: '',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'error-page' },
];
